import React from 'react';
import PageWithSidebars from './Page/PageWithSidebars.jsx';

export default class ContactPage extends React.PureComponent {
  render() {
    return (
      <PageWithSidebars removeAds>
        <div style={{ margin: '-.6rem 0 0 -.6rem' }}>
          <iframe src="https://docs.google.com/a/mtgx.se/forms/d/e/1FAIpQLSeiktkmk_YRS8SOWNtesLWWE9jYfpeQstJIgCE7DxI4sWtodg/viewform?embedded=true&hl=se" width="100%" height="1200px" frameBorder="0" marginHeight="0" marginWidth="0" />
        </div>
      </PageWithSidebars>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ContactPage.jsx